import {FacialBiometricEnum} from 'presentation/constants';

const BIOMETRIC_STEPS = [
	FacialBiometricEnum.FACIAL_BIOMETRIC,
	FacialBiometricEnum.FACE_PHOTO,
	FacialBiometricEnum.DOCUMENT_PHOTO,
	FacialBiometricEnum.SUCCESS,
];

export {BIOMETRIC_STEPS};
